import { render, staticRenderFns } from "./CorporationView.vue?vue&type=template&id=39699ff8"
import script from "./CorporationView.vue?vue&type=script&lang=js"
export * from "./CorporationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports